import { Box, Table } from '@mantine/core';
import CardEmpty from 'components/CardEmpty/CardEmpty';
import TableHeader from 'containers/OrdersList/OrdersListTable/TableHeader';

import ItemDetail from './ItemDetail';
import ModifierDetail from './ModifierDetail';
import FlagBadge from './FlagBadge';
import { MappingBadge } from './MappingBadge';
import ParentNames from './ParentNames';
import RowCheckbox from './RowCheckbox';
import RowActions from './RowActions';
import { Column, Item } from './types';

type MappingTableProps = {
  columns: Column[];
  dataSource: Item[];
  isModifierSelected?: boolean;
};

export default function MappingTable({
  columns,
  dataSource,
  isModifierSelected,
}: MappingTableProps) {
  if (!dataSource.length) {
    return (
      <Box mt="md">
        <CardEmpty message="No Data Available" />
      </Box>
    );
  }

  // eslint-disable-next-line no-confusing-arrow
  const tableHeaders = columns.map(column =>
    column?.sorter && column?.filters ? (
      <Table.Th key={column.key}>
        <TableHeader
          label={typeof column.title === 'string' ? column.title : ''}
          labelKey={column.labelKey || ''}
          handleOnSort={column.sorter}
          filters={column.filters}
        />
      </Table.Th>
    ) : (
      <Table.Th key={column.key}>{column.title}</Table.Th>
    ),
  );

  const rows = dataSource.map(item => (
    <Table.Tr key={item.key}>
      <Table.Td>
        <RowCheckbox rowIdentifier={item.key} />
      </Table.Td>
      <Table.Td>
        <MappingBadge status={item.mappingStatus} externalId={item.uuidExternalId} />
      </Table.Td>
      <Table.Td>{item.name}</Table.Td>
      <Table.Td>{item.price}</Table.Td>
      {item?.modifierGroup?.[0] && <Table.Td>{item.modifierGroup[0]}</Table.Td>}
      {item?.grandparentNames?.[0] && (
        <Table.Td>
          <ParentNames itemName={item.name} parentNames={item.grandparentNames} />
        </Table.Td>
      )}
      {item?.category?.[0] && <Table.Td>{item.category[0]}</Table.Td>}
      <Table.Td>
        {isModifierSelected ? <ModifierDetail item={item} /> : <ItemDetail item={item} />}
      </Table.Td>
      <Table.Td>{item.confidence}</Table.Td>
      <Table.Td>
        <FlagBadge item={item} />
      </Table.Td>
      <Table.Td>
        <RowActions isModifierSelected={isModifierSelected} row={item} />
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Table mr="md">
      <Table.Thead>
        <Table.Tr variant="solid">{tableHeaders}</Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </Table>
  );
}
